<template>
  <div>
    <p>
      <span style="color: blue">Geofence Type</span> Page to configure type of
      Geofence
    </p>

    <GeofenceCategoryForm
      :addNewGeofenceCategory="openModal"
      :title="titleModal"
      :editMode="editMode"
      :dataEdit="dataEdit"
      @closeModal="closeModal()" />
    <div class="p-4">
      <template
        class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <!-- ITEMS PER PAGE -->
        <vs-table
          class=""
          striped
          :data="data"
          search
          :max-items="itemsPerPage">
          <template #header>
            <div class="flex flex-wrap-reverse items-center justify-between">
              <vs-button
                size="medium"
                class="mr-3"
                icon-pack="feather"
                icon="icon-plus"
                icon-before
                color="primary"
                type="border"
                @click="addCategoryOpenModal()"
                >Add New
              </vs-button>
            </div>
          </template>

          <template #thead>
            <vs-th>No</vs-th>
            <vs-th>GEOFENCE TYPE</vs-th>
            <vs-th>Ignore alerts DRY</vs-th>
            <vs-th>Ignore alerts FRESH</vs-th>
            <vs-th>Alert IN </vs-th>
            <vs-th>Alert OUT </vs-th>
            <vs-th>Overspeed threshold</vs-th>
            <vs-th>Overstay ON Threshold Dry</vs-th>
            <vs-th>Overstay OFF Threshold Dry</vs-th>
            <vs-th>Overstay ON Threshold Fresh</vs-th>
            <vs-th>Overstay OFF Threshold Fresh</vs-th>
            <vs-th>Action</vs-th>
          </template>

          <template>
            <tbody>
              <vs-tr :key="index" v-for="(item, index) in data" :data="item">
                <vs-td> {{ index + 1 }} </vs-td>
                <vs-td v-if="item.geofence_type">
                  {{ item.geofence_type }}
                </vs-td>
                <vs-td v-if="item.ignore_alerts_dry">
                  <!-- {{  }} -->
                  {{
                    JSON.parse(item.ignore_alerts_dry)
                      .map((x) => x)
                      .join(', ')
                  }}
                </vs-td>
                <vs-td v-if="item.ignore_alerts_fresh">
                  <!-- {{  }} -->
                  {{
                    JSON.parse(item.ignore_alerts_fresh)
                      .map((x) => x)
                      .join(', ')
                  }}
                </vs-td>
                <vs-td>
                  <vs-icon
                    icon-pack="feather"
                    size="small"
                    :icon="item.alert_in ? 'icon-check' : 'icon-x'"
                    :color="item.alert_in ? 'green' : 'red'"
                    :style="
                      item.alert_in
                        ? 'border: 1px solid green; border-radius: 20%;'
                        : 'border: 1px solid red; border-radius: 20%;'
                    " />
                </vs-td>
                <vs-td>
                  <vs-icon
                    icon-pack="feather"
                    size="small"
                    :icon="item.alert_out ? 'icon-check' : 'icon-x'"
                    :color="item.alert_out ? 'green' : 'red'"
                    :style="
                      item.alert_out
                        ? 'border: 1px solid green; border-radius: 20%;'
                        : 'border: 1px solid red; border-radius: 20%;'
                    "
                /></vs-td>
                <vs-td> {{ item.overspeed }} Km/s </vs-td>
                <vs-td> {{ item.overstay_on_dry }} Menit</vs-td>
                <vs-td> {{ item.overstay_off_dry }} Menit</vs-td>
                <vs-td> {{ item.overstay_on_fresh }} Menit</vs-td>
                <vs-td> {{ item.overstay_off_fresh }} Menit</vs-td>
                <vs-td>
                  <div class="flex justify-start">
                    <vs-button
                      @click="handleClick(item)"
                      color="warning"
                      class="mr-2">
                      Edit
                    </vs-button>
                    <vs-button
                      @click="deleteGeofenceCategory(item.id)"
                      color="danger"
                      class="mr-2">
                      Delete
                    </vs-button>
                  </div>
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>

        <template>
          <vs-pagination v-model="page" :total="total_page" />
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import GeofenceCategoryForm from './GeofenceCategoryForm.vue'
import * as REPO from '../../../repository/index'
import { computed } from 'vue'
import { watch } from 'vue'

export default {
  components: {
    GeofenceCategoryForm,
  },
  data() {
    return {
      openModal: false,
      titleModal: 'Add new Geofence Type',
      data: [],
      editMode: false,
      dataEdit: {},
      total_page: 10,
      page: 1,
    }
  },
  methods: {
    addCategoryOpenModal() {
      this.openModal = true
      this.editMode = false
    },
    closeModal() {
      this.openModal = false
      this.editMode = false
      this.getListGeofenceCategory({ page: this.page })
    },
    handleClick(tr) {
      this.openModal = true
      this.titleModal = 'Edit Geofence Type'
      this.editMode = true

      this.dataEdit = JSON.parse(JSON.stringify(tr))
      this.dataEdit.ignore_alerts_dry = JSON.parse(tr.ignore_alerts_dry)
      this.dataEdit.ignore_alerts_fresh = JSON.parse(tr.ignore_alerts_fresh)
      this.dataEdit.vehicle_type = JSON.parse(tr.vehicle_type)
    },
    getListGeofenceCategory(val) {
      REPO.getListGeofenceCategory(val)
        .then((res) => {
          this.data = res.data.data.data
          this.total_page = res.data.data.last_page
          this.page = res.data.data.current_page
        })
        .catch((err) => {})
    },
    deleteGeofenceCategory(id) {
      REPO.deleteGeofenceCategory(id)
        .then((res) => {
          this.getListGeofenceCategory({ page: this.page })

          this.$vs.notify({
            title: 'Success',
            text: 'Success Delete Data',
            color: 'success',
            position: 'top-right',
          })
        })
        .catch((err) => {
          this.$vs.notify({
            title: 'Error',
            text: err.response.data,
            color: 'danger',
            position: 'top-right',
          })
        })
    },
  },
  computed: {},
  watch: {
    page(val) {
      this.page = val
      console.log(val)
      this.getListGeofenceCategory({
        limit: this.itemsPerPage,
        page: this.page,
      })
    },
  },
  created() {
    this.getListGeofenceCategory()
  },
}
</script>

<style>
.vs-table {
  border-collapse: separate;
  border-spacing: 0 1.3rem;
  padding: 0 1rem;

  tr {
    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

    td {
      padding: 20px;

      &:first-child {
        border-top-left-radius: 0.5rem;
        border-bottom-left-radius: 0.5rem;
      }

      &:last-child {
        border-top-right-radius: 0.5rem;
        border-bottom-right-radius: 0.5rem;
      }
    }

    td.td-check {
      padding: 20px !important;
    }
  }

  .vs-table--thead {
    th {
      padding-top: 0;
      padding-bottom: 0;

      .vs-table-text {
        text-transform: uppercase;
        font-weight: 600;
      }
    }

    th.td-check {
      padding: 0 15px !important;
    }

    tr {
      background: none;
      box-shadow: none;
    }
  }
}
</style>
